import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Button, Dropdown } from 'react-bootstrap'
import { browserHistory } from 'react-router'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import _ from 'lodash'

import CustomButton from '../../CustomButton';

import { tableExportOptions } from '../../helpers/table'
import { formatChannelStatus, formatChannelStatusCSV, formatDataUsage, formatDataUsageCSV, formatFailStatus, formatFirmwareCSV, formatFirmwareStatus, formatGroup, formatOnlineStatus, formatOnlineStatusCSV, formatRecordingStatus, formatRecordingStatusCSV, formatTimestamp, formatVehicleName } from '../../helpers/tablesFuncHelpers'
import { filterIcon } from '../../helpers/iconHelpers'
import { redirectToRoscoLive } from '../../helpers/helperRedirect'
import { getDeviceStatusName } from '../../helpers/helperVehicle'
import { isInternalUser } from '../../helpers/constants'
import { getDeviceById, getAllDevices } from '../../../action/DeviceActions'

import '../../dump/menuComponents/menuComponents.sass'
import '../../dump/menuComponents/manageVehicles.sass'

momentDurationFormatSetup(moment)

const ManageAssetsContainer = (props) => {
	const { user, companyData, initialData, devices, selectedDevices, filterColumn, filterConfigColumn, selectProfile, columns, page, sizePerPage, totalSize, handlePageChange, handleSizePerPageChange, sortDevicesName, sortDevicesOrder, handleDevicesSortChange } = props

	const [groups, setGroups] = useState([]);
	const [sortGroupNames, setSortGroupNames] = useState(true);

	useEffect(() => {
		const initialGroups = initialData.reduce((totalGroups, { group_name }) => {
			if (group_name) {
				!totalGroups.includes(group_name) && totalGroups.push(group_name)
			}
			else {
				!totalGroups.includes('No group') && totalGroups.push('No group')
			}
			// if (groups[0]) {
			// 	!totalGroups.includes(groups[0]) && totalGroups.push(groups[0])
			// }
			// else {
			// 	!totalGroups.includes('No group') && totalGroups.push('No group')
			// }
			return totalGroups.sort()
		}, []);

		setGroups(initialGroups);

		devices.map((item) => {
			item.cameraError = (item.channel_status && item.channel_status.length && item.channel_status.find(channel => channel.fail_ts > (channel.success_ts || '1970-01-01 00:00:00') && item.channel_available.includes(channel.channel))) ? 1 : 0;
			item.recordingError = (!_.isEmpty(item.latest_hdderror) && item.latest_hdderror.count) > 0 ? 1 : 0;
			item.recordingError = (!_.isEmpty(item.latest_hdderror) && item.latest_hdderror.count) > 0 ? 1 : 0;

			// FWSD-4314 - If device does not receive GPS from device and ignition is Off more 24 hours (1440 mins) then display Online status.
			// Device stopped receive GPS, broken antena or something, and FileServer does not know when ignition is On.
			// if ((row.ignition && row.ignition.state) || (!row.gps_online && durationInMins > 1440)) {
			let onlineStatus = 'parking'
			if (!item.online) {
				onlineStatus = 'offline'
			} else {
				// const ignitionOffTS = item.ignition && item.ignition.ts ? item.ignition.ts : ''; // 2023-01-04 18:50:37
				// const duration = moment.duration(moment.utc().diff(moment.utc(ignitionOffTS), 'seconds'), 'seconds')
				// const durationInMins = duration.asMinutes()

				if ((item.ignition && item.ignition.state) /*|| (!item.gps_online && durationInMins > 1440)*/) {
					onlineStatus = 'online'
				}
			}
			item.onlineStatus = onlineStatus

			return item;
		})
	}, [initialData]);

	// const auditLogFormatter = (e, device) => {
	// 	return (
	// 		<CustomButton
	// 			variant="link"
	// 			onClick={() => {
	// 				setShowModalDeviceAuditLog(true)
	// 				setActiveDevice(device)
	// 			}}
	// 		>
	// 			View
	// 		</CustomButton>
	// 	)
	// }

	const handleFailureChannelClick = (row, channel) => {
		setShowModalChannelStatus(true)
		setActiveDevice(row)
		setActiveChannel(channel)
	}

	const formatRecordingStatus = (cell) => {
		if (!cell) {
			return <span>OK</span>
		}
		return <span className="error-label">Needs Reformat</span>
	}

	const formatRecordingStatusCSV = (cell) => (!cell ? 'OK' : 'Needs Reformat')

	const { channelStatus, group, configProfile, onlineStatus, dataUsage, recordingStatus, /* firmwareStatus, */ firstConnected, id, auditLog, vinNumber, plateNumber, imei } = columns;

	const formatCameraName = (cell, row) => {
		let company_id;
		companyData.map(elm => { if (elm.company_name === row.company_name) company_id = elm.id });

		return (
			<CustomButton variant="link" style={{ whiteSpace: 'normal' }} onClick={() => redirectToRoscoLive('vehicle', company_id, row.device_id)}>{cell || '[Unnamed]'}</CustomButton>
		)
	}

	const handleSortGroupsClick = (sortGroupNames) => {
		setSortGroupNames(sortGroupNames);
		let data = groups;
		sortGroupNames ? setGroups(data.sort()) : setGroups(data.sort().reverse());
	}

	const formatCompanyName = (company_name) => {
		let company_id;
		companyData.map(elm => { if (elm.company_name === company_name) company_id = elm.id });

		return (
			<CustomButton variant="link" onClick={(e) => redirectToRoscoLive('vehiclescompany', company_id)}>{company_name}</CustomButton>
		)
	}

	const formatProfileName = (cell, row, isCSV = false) => {
		const { config_checksum, pending_company_profile, uploaded_company_profile } = row
		let company_id;
		companyData.map(elm => { if (elm.company_name === row.company_name) company_id = elm.id });

		if (config_checksum === 1) {
			if (pending_company_profile && pending_company_profile.toLowerCase() !== 'manual') {
				return !isCSV
					? <span>Pending update to <CustomButton variant="link" name={pending_company_profile} onClick={(e) => redirectToRoscoLive('profile', company_id, uploaded_company_profile)}>{pending_company_profile}</CustomButton></span>
					: `Pending update to ${pending_company_profile}`
			}
			return 'Pending update to Manual'
		}
		if (uploaded_company_profile) {
			return uploaded_company_profile === 'Manual'
				? 'Manual'
				: !isCSV
					? <CustomButton variant="link" name={uploaded_company_profile} onClick={(e) => redirectToRoscoLive('profile', company_id, uploaded_company_profile)}>{uploaded_company_profile}</CustomButton>
					: uploaded_company_profile
		}

		return 'Manual'
	}

	const filterValues = [...new Set(initialData.map(d => {
		if (d && d.config_checksum === 1) {
			return 'Pending'
		}
		if (d && d.uploaded_company_profile) {
			return d.uploaded_company_profile
		}
		return 'Manual'
	}))];

	const configProfileFilter = () => {
		let filterList = [];
		for (const value of filterValues.sort()) {
			if (value) {
				filterList.push(
					<li
						key={value}
						title={value}
					>
						<input type="checkbox" checked={isConfigChecked(value)} onChange={(e) => filterConfigColumn(e, value)} />
						<span className="groupName">{value || 'Manual'}</span>
					</li>
				);
			}
		}
		return filterList;
	}

	const isConfigChecked = (value) => {
		let devicesUpdate = devices;
		if (value === 'Manual') {
			return devicesUpdate.filter(e => e['config_checksum'] !== 1 && (e['uploaded_company_profile'] === 'Manual' || !e['uploaded_company_profile'])).length;;
		}
		else if (value === 'Pending') {
			return devicesUpdate.filter(e => e['config_checksum'] === 1).length;
		}
		return devicesUpdate.filter(e => e['uploaded_company_profile'] === value).length;
	}

	const numberOfSelectedDevices = () => {
		let devicesUpdate = devices;
		let i = 0;
		devicesUpdate.map(device => { if (!!device.activated_timestamp) i++ });
		return i;
	}

	const formatOnlineStatusLocal = (cell, row) => {
		const getTime = () => {
			if (row.status === 'parked' && row.ignition && row.ignition.ts) {
			 	return <>{moment.duration(moment.utc().diff(moment.utc(row.ignition.ts || ''), 'seconds'), 'seconds').format('hh:mm:ss', { trim: false })}</>
			}
			if (row.status === 'offline' && row.last_disconnected_ts) {
			 	return <>{`Since ${formatTimestamp(row.last_disconnected_ts, true)}`}</>
			}
		}

		return (
			<div className="status-row">
				<div className={`icon ${row.status.replace(' ', '_')}`} />
				<span className="title">
					{getDeviceStatusName(row.status)}
					<span className="status-time">{getTime()}</span>
				</span>
			</div>
		)
	}

	const formatOnlineStatusCSVLocal = (cell, row) => {
		const statusName = getDeviceStatusName(row.status)
		const getTime = () => {
			if (row.status === 'parked' && row.ignition && row.ignition.ts) {
				 return moment.duration(moment.utc().diff(moment.utc(row.ignition.ts || ''), 'seconds'), 'seconds').format('hh:mm:ss', { trim: false })
			}
			if (row.status === 'offline' && row.last_disconnected_ts) {
				 return `Since ${formatTimestamp(row.last_disconnected_ts, true)}`
			}
	
			return ''
		}
	
		return statusName.charAt(0).toUpperCase() + statusName.slice(1) + ' ' + getTime()
	}

	// DETERMINE TABLE MIN-HEIGHT BASED ON DROPDOWNS
	// const tableHeight = `${(groups.length > filterValues.length ? groups.length : filterValues.length) * 20 + 140}px`;
	const tableHeight = '0px';

	return (
		<div className="manage-assets-table">
			<BootstrapTable
				data={devices}
				{...tableExportOptions}
				options={{
					...tableExportOptions.options,
					onPageChange: handlePageChange,
					onSizePerPageList: handleSizePerPageChange,
					page,
					sizePerPage,
					sortName: sortDevicesName,
					sortOrder: sortDevicesOrder,
					onSortChange: handleDevicesSortChange,
					// defaultSortName: 'vehicle_name',
					// defaultSortOrder: 'asc',
				}}
				remote
				fetchInfo={{ dataTotalSize: totalSize }}
				tableStyle={{ minHeight: tableHeight }}
				tableContainerClass="rosco-table manage-vehicles-table"
				headerContainerClass="rosco-table-header manage-vehicles-table-header"
				bodyContainerClass="rosco-table-body manage-vehicles-table-body"
				csvFileName="camera_status_report.csv"
			>
				<TableHeaderColumn
					width="10%"
					dataField="vehicle_name"
					dataFormat={formatCameraName}
					csvFormat={formatVehicleName}
					isKey
					tdStyle={{ whiteSpace: 'normal', wordBreak: 'break-all' }}
					csvHeader="Camera Name"
					dataSort
				>
					<label className="camera-name-label">Vehicle Name</label>
				</TableHeaderColumn>
				<TableHeaderColumn
					width="10%"
					dataField="activated_timestamp"
					dataFormat={formatTimestamp}
					csvFormat={formatTimestamp}
					csvHeader="First Connected"
					hidden={!columns['Activated Date']}
					dataSort
				>
					Activated Date
				</TableHeaderColumn>
				<TableHeaderColumn
					width="8%"
					dataField="company_name"
					dataFormat={formatCompanyName}
					csvFormat={formatCompanyName}
					csvHeader="Company"
					hidden={!columns['Company']}
					dataSort
				>
					Company
				</TableHeaderColumn>
				<TableHeaderColumn
					width="8%"
					dataField="current_driver"
					csvHeader="Current Driver"
					hidden={!columns['Current Driver']}
					dataSort
				>
					Current Driver
				</TableHeaderColumn>
				<TableHeaderColumn
					width="7%"
					dataField="cameraError"
					dataFormat={(cell, row) => formatChannelStatus(row.channel_status, row, handleFailureChannelClick)}
					csvFormat={formatChannelStatusCSV}
					csvHeader="Channel Status"
					hidden={!columns['Channel Status']}
					// dataSort
				>
					Channel Status
				</TableHeaderColumn>
				<TableHeaderColumn
					width="7%"
					dataField="data_usage"
					dataFormat={(cell, row) => formatDataUsage(cell, row, companyData.filter(e => e.company_name === row.company_name)[0])}
					csvFormat={(cell, row) => formatDataUsageCSV(cell, row, companyData.filter(e => e.company_name === row.company_name)[0])}
					csvHeader="Data Usage"
					hidden={!columns['Data Usage']}
					dataSort
				>
					Data Usage
				</TableHeaderColumn>
				<TableHeaderColumn
					width="8%"
					dataField="device_id"
					csvHeader="Device ID"
					hidden={!columns['Device ID']}
					dataSort
				>
					Device ID
				</TableHeaderColumn>
				<TableHeaderColumn
					width="8%"
					dataField="group_name"
					dataFormat={formatGroup}
					csvHeader="Group Name"
					hidden={!columns['Group']}
					className="with-filter"
				>
					<div className="filter-wrapper">
						<label className="filter-label">Group Name</label>
						<Dropdown drop id="type-filter-btn" className="filter-dropdown">
							<Dropdown.Toggle as='span' className="typeFilter" bsPrefix="no-caret">
								{filterIcon}
							</Dropdown.Toggle>
							<Dropdown.Menu className="typeFilterMenu">
								<div className="groups-header">
									<h5 className="category-title">Groups</h5>
									<span className={`order ${sortGroupNames ? 'dropup' : ''}`}><span className="caret" onClick={() => handleSortGroupsClick(!sortGroupNames)}></span></span>
								</div>
								{groups.map(groupItem => {
									return (
										<li
											key={groupItem}
											title={groupItem}
										>
											<input
												type="checkbox"
												checked={groupItem === 'No group' ? devices.filter(e => !e.group_name).length : devices.filter(e => e.group_name === groupItem).length}
												onChange={(e) => filterColumn(e, 'group_name', groupItem)}
											/>
											<span className="groupName">{groupItem}</span>
										</li>
									)
								})}
								<div className="clear-all-container">
									<CustomButton variant="primary-outline" size="sm" prefix="clear-all" onClick={(e) => filterColumn(e, 'clear_all')}>
										{`${devices.length === 0 ? 'Select' : 'Clear'} All`}
									</CustomButton>
								</div>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</TableHeaderColumn>
				<TableHeaderColumn
					width="8%"
					dataField="simcard_iccid"
					csvHeader="ICCID"
					hidden={!columns['ICCID']}
					dataSort
				>
					ICCID
				</TableHeaderColumn>
				<TableHeaderColumn
					width="10%"
					dataField="serial_number"
					csvHeader="IMEI"
					hidden={!columns['IMEI']}
					dataSort
				>
					IMEI
				</TableHeaderColumn>
				<TableHeaderColumn
					width="8%"
					dataField="install_report"
					csvHeader="Install Report"
					hidden={!columns['Install Report']}
					dataSort
				>
					Install Report
				</TableHeaderColumn>
				<TableHeaderColumn
					width="11%"
					dataField="status"
					// dataFormat={formatOnlineStatus}
					dataFormat={formatOnlineStatusLocal}
					csvFormat={formatOnlineStatusCSVLocal}
					csvHeader="Activity Status"
					className="with-filter"
					columnClassName="fleet-activity-status"
					hidden={!columns['Activity Status']}
				>
					<div className="filter-wrapper">
						<label className="filter-label">Activity Status</label>
						<Dropdown drop id="type-filter-btn" className="filter-dropdown">
							<Dropdown.Toggle as='span' bsPrefix="no-caret" className="typeFilter">
								{filterIcon}
							</Dropdown.Toggle>
							<Dropdown.Menu className="typeFilterMenu">
								<h5 className="category-title">Activity Status</h5>
								<li
									key="online"
									title="Driving"
								>
									<input type="checkbox" checked={devices.filter(e => e.status === 'driving').length} onChange={(e) => filterColumn(e, 'status', 'driving')} />
									<span className="groupName">Driving</span>
								</li>
								<li
									key="parked"
									title="Parked"
								>
									<input type="checkbox" checked={devices.filter(e => e.status === 'parked').length} onChange={(e) => filterColumn(e, 'status', 'parked')} />
									<span className="groupName">Parked</span>
								</li>
								<li
									key="offline"
									title="Offline"
								>
									<input type="checkbox" checked={devices.filter(e => e.status === 'offline').length} onChange={(e) => filterColumn(e, 'status', 'offline')} />
									<span className="groupName">Offline</span>
								</li>
								<li
									key="disabled"
									title="Disabled"
								>
									<input type="checkbox" checked={devices.filter(e => e.status === 'disabled').length} onChange={(e) => filterColumn(e, 'status', 'disabled')} />
									<span className="groupName">Disabled</span>
								</li>
								{/* <li
									key="sleep"
									title="Sleep"
								>
									<input type="checkbox" checked={devices.filter(e => e.status === 'sleep').length} onChange={(e) => filterColumn(e, 'status', 'sleep')} />
									<span className="groupName">Sleep</span>
								</li>
								<li
									key="awake"
									title="Awake"
								>
									<input type="checkbox" checked={devices.filter(e => e.status === 'awake').length} onChange={(e) => filterColumn(e, 'status', 'awake')} />
									<span className="groupName">Awake</span>
								</li>
								<li
									key="pending sleep"
									title="Going To Sleep"
								>
									<input type="checkbox" checked={devices.filter(e => e.status === 'pending sleep').length} onChange={(e) => filterColumn(e, 'status', 'pending sleep')} />
									<span className="groupName">Going To Sleep</span>
								</li>
								<li
									key="pending awake"
									title="Waking Up"
								>
									<input type="checkbox" checked={devices.filter(e => e.status === 'pending awake').length} onChange={(e) => filterColumn(e, 'status', 'pending awake')} />
									<span className="groupName">Waking Up</span>
								</li>
								*/}
								<div className="clear-all-container">
									<CustomButton variant="primary-outline" size="sm" prefix="clear-all" onClick={(e) => filterColumn(e, 'clear_all')}>
										{`${devices.length === 0 ? 'Select' : 'Clear'} All`}
									</CustomButton>
								</div>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</TableHeaderColumn>
				<TableHeaderColumn
					width="8%"
					dataField="uploaded_company_profile"
					dataFormat={formatProfileName}
					csvFormat={(cell, row) => formatProfileName(cell, row, true)}
					csvHeader="Config Profile"
					className="with-filter"
					hidden={!columns['Settings Profile']}
				>
					<div className="filter-wrapper">
						<label className="filter-label">Settings Profile</label>
						<Dropdown drop id="type-filter-btn" className="filter-dropdown">
							<Dropdown.Toggle as='span' bsPrefix="no-caret" className="typeFilter config-filter">
								{filterIcon}
							</Dropdown.Toggle>
							<Dropdown.Menu className="typeFilterMenu">
								<h5 className="category-title">Settings Profile</h5>
								{configProfileFilter()}
								<div className="clear-all-container">
									<CustomButton variant="primary-outline" size="sm" prefix="clear-all" onClick={(e) => filterColumn(e, 'clear_all')}>
										{`${devices.length === 0 ? 'Select' : 'Clear'} All`}
									</CustomButton>
								</div>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</TableHeaderColumn>
				<TableHeaderColumn
					width="10%"
					dataField="tag_plate"
					csvHeader="License Plate Number"
					hidden={!columns['License Plate']}
					dataSort
				>
					License Plate Number
				</TableHeaderColumn>
				<TableHeaderColumn
					width="8%"
					dataField="vin_number"
					csvHeader="VIN"
					hidden={!columns['VIN']}
					dataSort
				>
					VIN Number
				</TableHeaderColumn>
			</BootstrapTable>
		</div>
	)
}

ManageAssetsContainer.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired
};

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
)(ManageAssetsContainer);
